export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      products: "Products",
      workflows: "Workflows",
      solutions: "Solutions",
      contact: "Contact",
      aiCta: "Talk to AI Assistant",
    },
    hero: {
      eyebrow: "AI AUTOMATION AGENCY",
      title1: "Automate Your",
      title2: "Business",
      title3: "with AI.",
      subtitle:
        "FIKAMI builds complete digital systems with AI bots, websites, voice & WhatsApp automation, POS solutions, SaaS platforms and workflow integrations.",
      ctaPrimary: "Talk to AI Assistant",
      ctaSecondary: "View Services",
      trust:
        "US-based AI automation agency — operating in Mexico, USA and Canada.",
      marquee: [
        "AI BOTS",
        "SMART WEBSITES",
        "WHATSAPP AUTOMATION",
        "VOICE AUTOMATION",
        "CRM WORKFLOWS",
        "POS SYSTEMS",
        "SAAS PLATFORMS",
        "CUSTOM DASHBOARDS",
      ],
    },
    services: {
      eyebrow: "WHAT WE BUILD",
      title: "Complete digital systems, engineered for conversion.",
      subtitle:
        "From the first click to the closed sale — every touchpoint is automated, measured, and optimized.",
      discover: "Ask the AI Assistant",
      items: [
        {
          key: "websites",
          title: "Smart Websites",
          desc: "High-performing business websites and landing pages designed to capture and convert.",
          points: [
            "Business websites",
            "Landing pages",
            "SEO structure",
            "Lead capture forms",
            "Mobile-first design",
            "Conversion tracking",
          ],
          icon: "fa-solid fa-globe",
        },
        {
          key: "ai",
          title: "AI Bots & Automation",
          desc: "Intelligent chat and voice agents that qualify leads and support customers 24/7.",
          points: [
            "AI chatbots",
            "AI voice bots",
            "WhatsApp automation",
            "Appointment scheduling",
            "Lead qualification",
            "Customer support automation",
          ],
          icon: "fa-solid fa-robot",
        },
        {
          key: "workflows",
          title: "Complete Business Workflows",
          desc: "End-to-end systems that connect ads, website, AI, CRM, scheduling, and sales.",
          points: [
            "Ads → Website → AI → CRM",
            "Workflow design",
            "Follow-up automation",
            "Customer journey optimization",
            "Omnichannel orchestration",
            "Analytics & dashboards",
          ],
          icon: "fa-solid fa-diagram-project",
        },
        {
          key: "pos",
          title: "POS Systems for Businesses",
          desc: "Point of sale platforms for restaurants and retail — fast, stable, and data-driven.",
          points: [
            "Point of sale systems",
            "Inventory",
            "Sales reports",
            "Customer management",
            "Restaurant workflows",
            "Retail workflows",
          ],
          icon: "fa-solid fa-cash-register",
        },
        {
          key: "saas",
          title: "SaaS & Custom Systems",
          desc: "Custom dashboards, reservation systems, client portals and scalable MVPs.",
          points: [
            "Custom dashboards",
            "Reservation systems",
            "Internal business tools",
            "MVP development",
            "Client portals",
            "Scalable web platforms",
          ],
          icon: "fa-solid fa-layer-group",
        },
      ],
    },
    workflow: {
      eyebrow: "HOW IT WORKS",
      title: "One connected system. Built around your business.",
      subtitle:
        "We don't build isolated websites — we engineer the full journey, from the first ad impression to the follow-up message.",
      steps: [
        { label: "Social Media / Ads", icon: "fa-solid fa-bullhorn" },
        { label: "Website", icon: "fa-solid fa-desktop" },
        { label: "AI Assistant", icon: "fa-solid fa-robot" },
        { label: "CRM / WhatsApp", icon: "fa-brands fa-whatsapp" },
        { label: "Appointment / Sale", icon: "fa-solid fa-calendar-check" },
        { label: "Follow-up Automation", icon: "fa-solid fa-rotate" },
      ],
    },
    why: {
      eyebrow: "WHY FIKAMI",
      title: "An agency built for automation-first businesses.",
      subtitle: "Strategy, engineering, and AI — under one roof.",
      items: [
        { title: "US-based company", desc: "FIKAMI LLC, registered and operated from the United States." , icon: "fa-solid fa-building-flag"},
        { title: "Bilingual service", desc: "Native English and Spanish — we speak your market.", icon: "fa-solid fa-language" },
        { title: "AI-first solutions", desc: "Every system is designed to automate, respond, and convert.", icon: "fa-solid fa-microchip" },
        { title: "Business automation strategy", desc: "We start with your workflow, not with a template.", icon: "fa-solid fa-chart-line" },
        { title: "Custom workflows", desc: "Tailored integrations that match how you actually operate.", icon: "fa-solid fa-diagram-next" },
        { title: "Scalable systems", desc: "Architecture that grows with your business, not against it.", icon: "fa-solid fa-arrow-trend-up" },
        { title: "Human support when needed", desc: "Automation where it wins, humans where it matters.", icon: "fa-solid fa-headset" },
      ],
    },
    ai: {
      eyebrow: "AI ASSISTANT",
      title: "Your automation starts with a conversation.",
      subtitle:
        "Tell our AI assistant about your business and receive a personalized automation recommendation — in seconds.",
      bullets: [
        "Identifies the right automation for your workflow",
        "Bilingual — English & Spanish",
        "No forms, no friction — just a conversation",
      ],
      ctaOpen: "Open AI Assistant",
      ctaSecondary: "Start AI Consultation",
    },
    consultation: {
      eyebrow: "NO PUBLIC PRICING",
      title: "Every business has a different workflow.",
      subtitle:
        "Talk to our AI assistant to receive a personalized automation recommendation — built around your goals, channels, and volume.",
      ctaPrimary: "Get a Custom Recommendation",
      ctaSecondary: "Automate My Business",
    },
    contact: {
      eyebrow: "LET'S TALK",
      title: "Ready to automate your business?",
      subtitle:
        "Tell our AI assistant about your business and receive a personalized automation recommendation. For formal inquiries, you can also reach us via email or WhatsApp.",
      ctaPrimary: "Talk to AI Assistant",
      emailLabel: "Email",
      whatsappLabel: "WhatsApp",
      hoursLabel: "Coverage",
      hoursValue: "Mexico · USA · Canada",
      secondaryNote: "Secondary channels",
      waMessage:
        "Hi FIKAMI — I'd like to explore automating my business.",
    },
    footer: {
      tagline:
        "US-based AI automation and workflow agency. Operating in Mexico, USA, and Canada.",
      links: "Navigate",
      legal: "Legal",
      contact: "Contact",
      privacy: "Privacy Policy",
      rights: "All rights reserved.",
    },
    floatingAI: {
      label: "Talk to AI Assistant",
      short: "AI Assistant",
    },
    modal: {
      title: "FIKAMI AI Assistant",
      subtitle:
        "Describe your business. Get a personalized automation recommendation.",
      close: "Close",
      live: "LIVE",
    },
    privacy: {
      title: "Privacy Policy",
      lastUpdated: "Last updated: February 2026",
      back: "Back to Home",
      intro:
        "This Privacy Policy explains how FIKAMI LLC handles personal information collected through this website, our AI assistant, contact forms, WhatsApp links, email communications, and consultation requests. We aim to keep this clear, simple, and modern — without unnecessary legal jargon.",
      sections: [
        {
          title: "1. Company responsible",
          body:
            "FIKAMI LLC is responsible for the processing of personal information collected through this website, contact forms, AI assistant interactions, WhatsApp links, email communications, and consultation requests.",
        },
        {
          title: "2. Information collected",
          body: "We may collect the following information when you interact with us:",
          list: [
            "Name",
            "Email address",
            "Phone number",
            "WhatsApp number",
            "Company or business name",
            "Country or region",
            "Type of business",
            "Messages submitted through forms or the AI assistant",
            "Consultation requests",
            "Technical information such as browser type, approximate location, device information, cookies, and analytics data",
          ],
        },
        {
          title: "3. Purpose of data use",
          body: "Personal information may be used to:",
          list: [
            "Respond to inquiries",
            "Provide personalized recommendations",
            "Prepare custom quotes",
            "Schedule consultations",
            "Operate the AI assistant",
            "Improve website experience",
            "Follow up with potential clients",
            "Provide customer support",
            "Maintain security and prevent abuse",
          ],
        },
        {
          title: "4. AI assistant and third-party tools",
          body:
            "Conversations with our AI assistant may be processed through third-party technology providers used to operate the chatbot and automation systems. These providers may temporarily store messages in order to deliver the service, improve responses, and maintain availability.",
        },
        {
          title: "5. Third-party services",
          body:
            "FIKAMI may use third-party providers to operate parts of the experience, including:",
          list: [
            "Website hosting",
            "Email communication",
            "AI chatbot technology",
            "Analytics",
            "CRM",
            "Calendar scheduling",
            "Automation tools",
          ],
        },
        {
          title: "6. No sale of personal data",
          body: "FIKAMI does not sell personal information.",
        },
        {
          title: "7. Cookies and analytics",
          body:
            "This website may use cookies or similar technologies to improve the website, measure traffic, and understand visitor behavior. You can control cookies through your browser settings.",
        },
        {
          title: "8. User rights",
          body:
            "You may request access to, correction of, deletion of, or limitation on the use of your personal information at any time by contacting us.",
        },
        {
          title: "9. Contact for privacy requests",
          body: "For privacy-related requests, please contact us at:",
          email: "miguelfierro@fikamillc.com",
        },
        {
          title: "10. Updates",
          body:
            "This Privacy Policy may be updated from time to time. The latest version will always be published on this website.",
        },
      ],
      disclaimer:
        "This page is for general informational purposes and should be reviewed by a legal professional if needed.",
    },
    cookies: {
      title: "We use cookies",
      body: "We use a few essential cookies and lightweight analytics to keep this site fast, useful, and secure.",
      learnMore: "Learn more",
      accept: "Accept",
      dismiss: "Dismiss",
    },
  },

  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      products: "Productos",
      workflows: "Flujos",
      solutions: "Soluciones",
      contact: "Contacto",
      aiCta: "Habla con el Asistente IA",
    },
    hero: {
      eyebrow: "AGENCIA DE AUTOMATIZACIÓN CON IA",
      title1: "Automatiza",
      title2: "tu negocio",
      title3: "con IA.",
      subtitle:
        "FIKAMI construye sistemas digitales completos con bots de IA, sitios web, automatización por voz y WhatsApp, soluciones POS, plataformas SaaS e integraciones de flujos de trabajo.",
      ctaPrimary: "Habla con el Asistente IA",
      ctaSecondary: "Ver servicios",
      trust:
        "Agencia de automatización con IA con sede en EE. UU. — operando en México, Estados Unidos y Canadá.",
      marquee: [
        "BOTS DE IA",
        "SITIOS WEB",
        "AUTOMATIZACIÓN WHATSAPP",
        "AUTOMATIZACIÓN DE VOZ",
        "FLUJOS CRM",
        "SISTEMAS POS",
        "PLATAFORMAS SAAS",
        "DASHBOARDS A MEDIDA",
      ],
    },
    services: {
      eyebrow: "LO QUE CONSTRUIMOS",
      title: "Sistemas digitales completos, diseñados para convertir.",
      subtitle:
        "Desde el primer clic hasta el cierre de venta — cada punto de contacto se automatiza, se mide y se optimiza.",
      discover: "Pregúntale al Asistente IA",
      items: [
        {
          key: "websites",
          title: "Sitios web inteligentes",
          desc: "Sitios web y landing pages de alto rendimiento, diseñadas para capturar y convertir.",
          points: [
            "Sitios web para negocios",
            "Landing pages",
            "Estructura SEO",
            "Formularios de captura",
            "Diseño mobile-first",
            "Seguimiento de conversión",
          ],
          icon: "fa-solid fa-globe",
        },
        {
          key: "ai",
          title: "Bots de IA y automatización",
          desc: "Agentes de chat y voz inteligentes que califican leads y atienden clientes 24/7.",
          points: [
            "Chatbots con IA",
            "Bots de voz con IA",
            "Automatización de WhatsApp",
            "Agendamiento de citas",
            "Calificación de leads",
            "Soporte al cliente automatizado",
          ],
          icon: "fa-solid fa-robot",
        },
        {
          key: "workflows",
          title: "Flujos completos para negocios",
          desc: "Sistemas de punta a punta que conectan anuncios, sitio web, IA, CRM, agenda y ventas.",
          points: [
            "Anuncios → Web → IA → CRM",
            "Diseño de flujos de trabajo",
            "Automatización de seguimiento",
            "Optimización del recorrido del cliente",
            "Orquestación omnicanal",
            "Analítica y dashboards",
          ],
          icon: "fa-solid fa-diagram-project",
        },
        {
          key: "pos",
          title: "Sistemas de punto de venta (POS)",
          desc: "Plataformas POS para restaurantes y retail — rápidas, estables y con datos.",
          points: [
            "Sistemas POS",
            "Inventario",
            "Reportes de ventas",
            "Gestión de clientes",
            "Flujos para restaurantes",
            "Flujos para retail",
          ],
          icon: "fa-solid fa-cash-register",
        },
        {
          key: "saas",
          title: "SaaS y sistemas personalizados",
          desc: "Dashboards a medida, sistemas de reservación, portales de clientes y MVPs escalables.",
          points: [
            "Dashboards personalizados",
            "Sistemas de reservación",
            "Herramientas internas",
            "Desarrollo de MVP",
            "Portales para clientes",
            "Plataformas web escalables",
          ],
          icon: "fa-solid fa-layer-group",
        },
      ],
    },
    workflow: {
      eyebrow: "CÓMO FUNCIONA",
      title: "Un sistema conectado. Diseñado para tu negocio.",
      subtitle:
        "No construimos sitios web aislados — diseñamos el recorrido completo, desde la primera impresión del anuncio hasta el mensaje de seguimiento.",
      steps: [
        { label: "Redes / Anuncios", icon: "fa-solid fa-bullhorn" },
        { label: "Sitio web", icon: "fa-solid fa-desktop" },
        { label: "Asistente IA", icon: "fa-solid fa-robot" },
        { label: "CRM / WhatsApp", icon: "fa-brands fa-whatsapp" },
        { label: "Cita / Venta", icon: "fa-solid fa-calendar-check" },
        { label: "Seguimiento automatizado", icon: "fa-solid fa-rotate" },
      ],
    },
    why: {
      eyebrow: "POR QUÉ FIKAMI",
      title: "Una agencia pensada para negocios automatización-first.",
      subtitle: "Estrategia, ingeniería e IA — bajo un mismo techo.",
      items: [
        { title: "Empresa con sede en EE. UU.", desc: "FIKAMI LLC, registrada y operada desde Estados Unidos.", icon: "fa-solid fa-building-flag" },
        { title: "Servicio bilingüe", desc: "Inglés y español nativos — hablamos tu mercado.", icon: "fa-solid fa-language" },
        { title: "Soluciones AI-first", desc: "Cada sistema está diseñado para automatizar, responder y convertir.", icon: "fa-solid fa-microchip" },
        { title: "Estrategia de automatización", desc: "Empezamos por tu flujo de trabajo, no por una plantilla.", icon: "fa-solid fa-chart-line" },
        { title: "Flujos personalizados", desc: "Integraciones a medida que se adaptan a cómo operas realmente.", icon: "fa-solid fa-diagram-next" },
        { title: "Sistemas escalables", desc: "Arquitectura que crece con tu negocio, no en contra.", icon: "fa-solid fa-arrow-trend-up" },
        { title: "Soporte humano cuando se necesita", desc: "Automatización donde gana, humanos donde importa.", icon: "fa-solid fa-headset" },
      ],
    },
    ai: {
      eyebrow: "ASISTENTE IA",
      title: "Tu automatización empieza con una conversación.",
      subtitle:
        "Cuéntale a nuestro asistente de IA sobre tu negocio y recibe una recomendación personalizada — en segundos.",
      bullets: [
        "Identifica la automatización ideal para tu flujo",
        "Bilingüe — español e inglés",
        "Sin formularios, sin fricción — solo una conversación",
      ],
      ctaOpen: "Abrir Asistente IA",
      ctaSecondary: "Iniciar consulta con IA",
    },
    consultation: {
      eyebrow: "SIN PRECIOS PÚBLICOS",
      title: "Cada negocio tiene un flujo diferente.",
      subtitle:
        "Habla con nuestro asistente de IA y recibe una recomendación personalizada para automatizar tu operación.",
      ctaPrimary: "Recibe una recomendación personalizada",
      ctaSecondary: "Automatiza mi negocio",
    },
    contact: {
      eyebrow: "HABLEMOS",
      title: "¿Listo para automatizar tu negocio?",
      subtitle:
        "Cuéntale a nuestro asistente de IA sobre tu negocio y recibe una recomendación personalizada. Para consultas formales también puedes escribirnos por correo o WhatsApp.",
      ctaPrimary: "Habla con el Asistente IA",
      emailLabel: "Correo",
      whatsappLabel: "WhatsApp",
      hoursLabel: "Cobertura",
      hoursValue: "México · EE. UU. · Canadá",
      secondaryNote: "Canales secundarios",
      waMessage:
        "Hola FIKAMI — me gustaría explorar la automatización de mi negocio.",
    },
    footer: {
      tagline:
        "Agencia de automatización con IA con sede en EE. UU. Operando en México, Estados Unidos y Canadá.",
      links: "Navegación",
      legal: "Legal",
      contact: "Contacto",
      privacy: "Aviso de privacidad",
      rights: "Todos los derechos reservados.",
    },
    floatingAI: {
      label: "Habla con el Asistente IA",
      short: "Asistente IA",
    },
    modal: {
      title: "Asistente IA de FIKAMI",
      subtitle:
        "Describe tu negocio. Recibe una recomendación de automatización personalizada.",
      close: "Cerrar",
      live: "EN VIVO",
    },
    privacy: {
      title: "Aviso de Privacidad",
      lastUpdated: "Última actualización: Febrero 2026",
      back: "Volver al inicio",
      intro:
        "Este Aviso de Privacidad explica cómo FIKAMI LLC trata la información personal recopilada a través de este sitio web, nuestro asistente de IA, formularios de contacto, enlaces de WhatsApp, comunicaciones por correo y solicitudes de consulta. Buscamos que sea claro, simple y moderno — sin tecnicismos legales innecesarios.",
      sections: [
        {
          title: "1. Empresa responsable",
          body:
            "FIKAMI LLC es responsable del tratamiento de la información personal recopilada a través de este sitio web, formularios de contacto, interacciones con el asistente de IA, enlaces de WhatsApp, comunicaciones por correo y solicitudes de consulta.",
        },
        {
          title: "2. Información que recopilamos",
          body: "Podemos recopilar la siguiente información cuando interactúas con nosotros:",
          list: [
            "Nombre",
            "Correo electrónico",
            "Número de teléfono",
            "Número de WhatsApp",
            "Empresa o nombre del negocio",
            "País o región",
            "Tipo de negocio",
            "Mensajes enviados a través de formularios o del asistente de IA",
            "Solicitudes de consulta",
            "Información técnica como tipo de navegador, ubicación aproximada, información del dispositivo, cookies y datos de analítica",
          ],
        },
        {
          title: "3. Finalidad del uso de los datos",
          body: "La información personal puede utilizarse para:",
          list: [
            "Responder consultas",
            "Brindar recomendaciones personalizadas",
            "Preparar cotizaciones a la medida",
            "Agendar consultas",
            "Operar el asistente de IA",
            "Mejorar la experiencia del sitio web",
            "Dar seguimiento a clientes potenciales",
            "Brindar soporte al cliente",
            "Mantener la seguridad y prevenir abusos",
          ],
        },
        {
          title: "4. Asistente de IA y herramientas de terceros",
          body:
            "Las conversaciones con nuestro asistente de IA pueden ser procesadas a través de proveedores tecnológicos externos utilizados para operar el chatbot y los sistemas de automatización. Estos proveedores pueden almacenar mensajes temporalmente para prestar el servicio, mejorar las respuestas y mantener la disponibilidad.",
        },
        {
          title: "5. Servicios de terceros",
          body:
            "FIKAMI puede utilizar proveedores externos para operar partes de la experiencia, incluyendo:",
          list: [
            "Hospedaje del sitio web",
            "Comunicación por correo electrónico",
            "Tecnología de chatbot con IA",
            "Analítica",
            "CRM",
            "Agendamiento en calendario",
            "Herramientas de automatización",
          ],
        },
        {
          title: "6. No venta de datos personales",
          body: "FIKAMI no vende información personal.",
        },
        {
          title: "7. Cookies y analítica",
          body:
            "Este sitio web puede utilizar cookies o tecnologías similares para mejorar la experiencia, medir el tráfico y comprender el comportamiento de los visitantes. Puedes administrar las cookies desde la configuración de tu navegador.",
        },
        {
          title: "8. Derechos del usuario",
          body:
            "Puedes solicitar el acceso, la corrección, la eliminación o la limitación del uso de tu información personal en cualquier momento contactándonos.",
        },
        {
          title: "9. Contacto para solicitudes de privacidad",
          body: "Para solicitudes relacionadas con privacidad, contáctanos en:",
          email: "miguelfierro@fikamillc.com",
        },
        {
          title: "10. Actualizaciones",
          body:
            "Este Aviso de Privacidad puede actualizarse de tiempo en tiempo. La versión más reciente siempre estará publicada en este sitio web.",
        },
      ],
      disclaimer:
        "Esta página tiene fines informativos generales y debe ser revisada por un profesional legal en caso necesario.",
    },
    cookies: {
      title: "Usamos cookies",
      body: "Utilizamos algunas cookies esenciales y analítica ligera para mantener el sitio rápido, útil y seguro.",
      learnMore: "Más información",
      accept: "Aceptar",
      dismiss: "Cerrar",
    },
  },
};
